import { ProposalDto } from '../../types/spool-local';
import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';
import useLatestProposal from './useLatestProposal';

const useUserAvailableVotingPower = () => {
    const { account } = useWeb3React();

    const { interfaceSDK } = useContext(appContext);

    const { latestProposal } = useLatestProposal();

    const { data, error } = useSWR(
        interfaceSDK && account && latestProposal
            ? ['userAvailableVotingPower', account, latestProposal]
            : null,
        async (_, userAddress, latestProposal: ProposalDto) => {
            const userAvailableVotingPower =
                await interfaceSDK!.get.getAccumulatedVoSpool(
                    userAddress!,
                    +latestProposal.snapshot!
                );
            return userAvailableVotingPower;
        }
    );

    return {
        userAvailableVotingPower: data?.toString(),
        isLoading: !error && !data,
        error,
    };
};

export default useUserAvailableVotingPower;
